export { default as FourDSvg } from './4d.svg';
export { default as BrightDataSvg } from './bright-data.svg';
export { default as DropboxSvg } from './dropbox.svg';
export { default as GoogleAdsSvg } from './google-ads.svg';
export { default as CivittaSvg } from './civitta.svg';
export { default as SlackSvg } from './slack.svg';
